import axios from "axios";
export default {
	data() {
		return {
			id: null,
			pathResource: "/dataanalysisdashboard",
			jsonData: { title: "", descrizione: "", dashboard: { headerElements: [], bodyElements: [] } },
			dashboard: { headerElements: [], bodyElements: [] },
		};
	},
	methods: {
		loadData() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
			axios.get(link + me.id)
				.then((response) => {
					me.jsonData = response.data.data;
					let tmpDashboard = JSON.parse(response.data.data.dashboard);
					me.dashboard.headerElements = tmpDashboard.headerElements.sort((a, b) => a.id - b.id);
					me.dashboard.bodyElements = tmpDashboard.bodyElements.sort((a, b) => a.id - b.id);
					this.$emit("updateDashBoard", response.data.data);
				})
				.catch((e) => {
					console.log(e);
				});
		},
	},
};
